<app-header></app-header>

<div class="container mt-5 mb-5">
  <div class="row">

    <div class="col-md-8">

      <app-pre-register-teacher *ngIf="!showCompleteRegister"></app-pre-register-teacher>

      <mat-horizontal-stepper *ngIf="showCompleteRegister" #stepper labelPosition="bottom" (selectionChange)="onChangeStep($event)">

        <!-- Step 2 -->
        <mat-step [stepControl]="form2" editable="true">
          <form [formGroup]="form2">
            <ng-template matStepLabel *ngIf="!isMobile">{{
              "teacher-info" | translate
            }}</ng-template>
            <div class="container-form margin-auto">
              <!-- Photo -->

              <div class="flex-center position-relative">
                <mat-icon
                  svgIcon="user"
                  *ngIf="!form2.value.photo; else photoTemplate"
                  (click)="photo.click()"
                  class="margin-top-1 gallery-icon"
                ></mat-icon>
                <input
                  #photo
                  type="file"
                  accept="image/png,image/jpeg"
                  (change)="onSelectFile($event.target, 'photo')"
                  style="display: none"
                />
                <div
                  class="flex-center question-container"
                  (click)="openPhotoAdvicesDialog()"
                >
                  <mat-icon class="question-icon" svgIcon="question"></mat-icon>
                </div>

                <ng-template #photoTemplate>
                  <img
                    id="photo"
                    class="margin-top-1 img-teacher"
                    (click)="photo.click()"
                  />
                </ng-template>
              </div>
              <div
                class="flex-center mat-caption margin-top-05 gray"
                [class.red]="
                  form2.controls.photo.invalid && form2.controls.photo.touched
                "
              >
                {{ "photo-required" | translate }}
              </div>

              <!-- Gender -->
              <mat-form-field appearance="legacy" class="margin-top-1">
                <mat-label>{{ "gender" | translate }}</mat-label>
                <mat-select class="form-control" formControlName="gender">
                  <mat-option [value]="gender" *ngFor="let gender of genders"
                    >{{ gender | translate }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="genderNoValido">
                  {{ "valid-gender" | translate }}
                </mat-error>
              </mat-form-field>

              <!-- Birthdate -->
              <mat-form-field appearance="legacy" class="margin-top-1">
                <mat-label>{{ "birthday" | translate }}</mat-label>
                <input
                  matInput
                  class="form-control"
                  formControlName="birthday"
                  [matDatepicker]="picker"
                  placeholder="DD/MM/YYYY"
                  autocomplete="off"
                  name="bday"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="picker"
                ></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
                <mat-error *ngIf="birthdayNoValido">
                  {{ "valid-date" | translate }}
                </mat-error>
              </mat-form-field>

              <!-- Phone -->
              <mat-form-field appearance="legacy" class="margin-top-1">
                <mat-label>{{ "phone" | translate }}</mat-label>
                <input
                  class="form-control"
                  matInput
                  formControlName="phone"
                  type="tel"
                  autocomplete="off"
                  name="tel"
                />
                <mat-error *ngIf="phoneNoValido">
                  {{ "valid-phone" | translate }}
                </mat-error>
              </mat-form-field>

              <!-- Country -->
              <app-autocomplete
                formControlName="country"
                label="country"
                validText="valid-select"
                [options]="countries"
                [atributeDisplay]="'name_' + general.translate.currentLang"
                [isInvalid]="form2.controls.country?.invalid && form2.controls.country?.touched"
              ></app-autocomplete>

              <!-- City -->
              <!--
              <app-autocomplete2
                formControlName="city"
                label="city"
                validText="valid-select"
                [options]="cities"
                [atributeDisplay]="'name'"
                [isInvalid]="
                  form2.controls.city?.invalid && form2.controls.city?.touched
                "
              >
              </app-autocomplete2>
              -->
              <mat-label>{{ "city" | translate }}</mat-label>
              <input matInput formControlName="city" type="text" placeholder='{{ "valid-city" | translate }}'>
              <mat-error *ngIf="invalidCity">
                {{ "valid-city" | translate }}
              </mat-error>
              <!-- DNI -->
              <mat-form-field appearance="legacy" class="margin-top-1">
                <mat-label>{{ "dni" | translate }}</mat-label>
                <input class="form-control" matInput formControlName="dni" type="text" />
                <mat-error *ngIf="dniNoValido">
                  {{ "valid-dni" | translate }}
                </mat-error>
              </mat-form-field>

              <!-- dni_front -->
              <div
                class="margin-top-1"
                [class.red]="
                  form2.controls.dni_front?.invalid &&
                  form2.controls.dni_front?.touched
                "
              >
                {{ "dni-front" | translate }}
              </div>
              <div class="flex-center">
                <mat-icon
                  svgIcon="gallery"
                  *ngIf="!form2.value.dni_front; else dniFrontTemplate"
                  (click)="dniFront.click()"
                  class="margin-top-1 gallery-icon"
                ></mat-icon>
                <input
                  #dniFront
                  type="file"
                  accept="image/png,image/jpeg,application/pdf,.doc,.docx"
                  (change)="onSelectFile($event.target, 'dni_front')"
                  style="display: none"
                />

                <ng-template #dniFrontTemplate>
                  <div
                    *ngIf="
                      form2.value.dni_front.type.includes('image/');
                      else fileTemplate
                    "
                    class="flex-center"
                  >
                    <img
                      id="dni_front"
                      class="margin-top-1 img"
                      (click)="dniFront.click()"
                    />
                  </div>
                  <ng-template #fileTemplate>
                    <div
                      class="flex-center-column margin-top-1 cursor-pointer"
                      (click)="dniFront.click()"
                    >
                      <mat-icon svgIcon="file" class="file-icon"></mat-icon>
                      <div class="margin-top-05">
                        {{ form2.value.dni_front.name }}
                      </div>
                    </div>
                  </ng-template>
                </ng-template>
              </div>
              <div class="mat-caption gray margin-top-05">
                {{ "file-limitator-text-1" | translate }}
              </div>

              <!-- Languages -->
              <div class="mat-h3 margin-top-2">
                {{ "languages-to-talk" | translate }}
              </div>
              <div formArrayName="languages">
                <mat-card
                  class="form-group margin-top-1 mat-elevation-z4"
                  *ngFor="
                    let subject of languagesFormArray.controls;
                    let index = index;
                    let last = last;
                    let first = first
                  "
                >
                  <div class="flex-end">
                    <button mat-icon-button (click)="removeLanguage(index)">
                      <mat-icon svgIcon="minus-circle" color="warn"></mat-icon>
                    </button>
                  </div>

                  <div [formGroupName]="index">
                    <mat-form-field appearance="legacy" class="margin-top-1">
                      <mat-label>{{ "language" | translate }}</mat-label>
                      <mat-select class="form-control" formControlName="language_id">
                        <mat-option
                          [value]="language.id"
                          *ngFor="let language of languages"
                          >{{ language.name }}
                        </mat-option>
                      </mat-select>
                      <mat-error
                        *ngIf="
                          subject.controls.language_id?.invalid &&
                          subject.controls.language_id?.touched
                        "
                      >
                        {{ "valid-select" | translate }}
                      </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="legacy" class="margin-top-05">
                      <mat-label>{{ "level" | translate }}</mat-label>
                      <mat-select class="form-control" formControlName="level_id">
                        <mat-option
                          [value]="level.id"
                          *ngFor="let level of languageLevels"
                          >{{ level.name }}
                        </mat-option>
                      </mat-select>
                      <mat-error
                        *ngIf="
                          subject.controls.level_id?.invalid &&
                          subject.controls.level_id?.touched
                        "
                      >
                        {{ "valid-select" | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                </mat-card>
                <div class="flex-center margin-top-1">
                  <button
                    type="button"
                    class="btn btn-success"
                    (click)="addLanguage()"
                  >
                    <div class="flex-center">
                      <span class="margin-right-05">{{
                        "add-another-1" | translate
                      }}</span>
                      <mat-icon svgIcon="plus"></mat-icon>
                    </div>
                  </button>
                </div>
              </div>

              <!-- Button -->
              <div class="button-group margin-top-1 margin-bottom-05">
                <button
                  mat-raised-button
                  color="primary"
                  type="button"
                  matStepperPrevious
                >
                  <span>{{ "previous" | translate }}</span>
                </button>
                <button
                  mat-raised-button
                  color="primary"
                  type="button"
                  matStepperNext
                >
                  <span>{{ "next" | translate }}</span>
                </button>
              </div>
            </div>
          </form>
        </mat-step>

        <!-- Step 3 -->
        <mat-step [stepControl]="form3" editable="true">
          <form [formGroup]="form3">
            <ng-template matStepLabel *ngIf="!isMobile">{{
              "more-information" | translate
            }}</ng-template>
            <div class="container-form margin-auto">
              <!-- description -->
              <div
                class="margin-top-1"
                style="
                  color: #272129 !important;
                  opacity: 0.5 !important;
                  font-size: 16px;
                  font-weight: 400;
                  line-height: 1.125;
                  font-family: Poppins;
                "
              >
                {{ "description-text" | translate }}
              </div>

              <mat-form-field appearance="legacy">
                <textarea
                  class="form-control"
                  matInput
                  formControlName="description"
                  type="text"
                ></textarea>
                <mat-error *ngIf="invalidDescription">
                  {{ "valid-description" | translate }}
                </mat-error>
              </mat-form-field>

              <!-- goal_joining -->
              <mat-form-field appearance="legacy" class="margin-top-1">
                <mat-label>{{ "goal_joining" | translate }}</mat-label>
                <mat-select class="form-control" formControlName="goal_joining">
                  <mat-option value="1">{{
                    "goal-joining-teacher-1" | translate
                  }}</mat-option>
                  <mat-option value="2">{{
                    "goal-joining-teacher-2" | translate
                  }}</mat-option>
                  <mat-option value="3">{{
                    "goal-joining-teacher-3" | translate
                  }}</mat-option>
                  <mat-option value="4">{{
                    "goal-joining-teacher-4" | translate
                  }}</mat-option>
                  <mat-option value="5">{{
                    "goal-joining-teacher-5" | translate
                  }}</mat-option>
                </mat-select>
                <mat-error *ngIf="invalidGoalJoining">
                  {{ "valid-select" | translate }}
                </mat-error>
              </mat-form-field>

              <!-- other_goal_joining -->
              <mat-form-field
                  *ngIf="form3.value.goal_joining === '5'"
                  appearance="legacy"
                  class="margin-top-1 form-control"
                >
                  <mat-label>{{ "other_goal_joining" | translate }}</mat-label>
                  <input matInput class="form-control" formControlName="other_goal_joining" type="text" />
                  <mat-error *ngIf="invalidOtherGoalJoining">
                    {{ "valid-input" | translate }}
                  </mat-error>
              </mat-form-field>

              <!-- educational_level -->
              <mat-form-field appearance="legacy" class="margin-top-1">
                <mat-label>{{ "educational_level" | translate }}</mat-label>
                <mat-select class="form-control" formControlName="educational_level">
                  <mat-option value="1">{{
                    "educational_level_teacher_1" | translate
                  }}</mat-option>
                  <mat-option value="2">{{
                    "educational_level_teacher_2" | translate
                  }}</mat-option>
                  <mat-option value="3">{{
                    "educational_level_teacher_3" | translate
                  }}</mat-option>
                  <mat-option value="4">{{
                    "educational_level_teacher_4" | translate
                  }}</mat-option>
                  <mat-option value="5">{{
                    "educational_level_teacher_5" | translate
                  }}</mat-option>
                </mat-select>
                <mat-error *ngIf="invalidEducationalLevel">
                  {{ "valid-select" | translate }}
                </mat-error>
              </mat-form-field>

              <!-- dedication_time -->
              <mat-form-field appearance="legacy" class="margin-top-1">
                <mat-label>{{ "dedication_time" | translate }}</mat-label>
                <mat-select class="form-control" formControlName="dedication_time">
                  <mat-option value="1">{{
                    "dedication_time_teacher_1" | translate
                  }}</mat-option>
                  <mat-option value="2">{{
                    "dedication_time_teacher_2" | translate
                  }}</mat-option>
                  <mat-option value="3">{{
                    "dedication_time_teacher_3" | translate
                  }}</mat-option>
                  <mat-option value="4">{{
                    "dedication_time_teacher_4" | translate
                  }}</mat-option>
                </mat-select>
                <mat-error *ngIf="invalidDedicationTime">
                  {{ "valid-select" | translate }}
                </mat-error>
              </mat-form-field>

            </div>

            <div
              class="mat-h2 margin-top-2 text-center"
              [class.red]="
                form3.controls?.scheedule_days?.errors?.required &&
                form3.controls?.scheedule_days?.touched
              "
            >
              {{ "calendar-title" | translate }}
            </div>
            <full-calendar
              [options]="calendarOptions"
              class="margin-top-1"
              #calendar
            >
            </full-calendar>
            <!-- <div
              id="delete_availability_slot"
              class="deleteSlot red"
              style="display: none"
              #menu
              (click)="removeLastEventClicked()"
            >
              <div>{{ "delete" | translate }}</div>
              <div class="arrow"></div>
            </div> -->

            <div class="container-form margin-auto">
              <!-- Button -->
              <div class="button-group margin-top-1 margin-bottom-05">
                <button
                  mat-raised-button
                  color="primary"
                  type="button"
                  matStepperPrevious
                >
                  <span>{{ "previous" | translate }}</span>
                </button>
                <button
                  mat-raised-button
                  color="primary"
                  type="button"
                  matStepperNext
                >
                  <span>{{ "next" | translate }}</span>
                </button>
              </div>
            </div>
          </form>
        </mat-step>

        <!-- Step 4 -->
        <mat-step [stepControl]="form4" editable="true">

          <form [formGroup]="form4">

            <ng-template matStepLabel *ngIf="!isMobile">{{"subjects-and-certificates" | translate}}</ng-template>
            
            <div class="container-form margin-auto">

              <div class="row margin-auto p-3">
                <div class="col-md-12 border p-3 rounded-card bg-white">
                  <!-- schoolar-subjects -->
                  <div formArrayName="subjects" class="row p-3 gx-2">
                    <div class="block" style="width: 100%;">
                      <h2 class=" pb-3 primary"><i class="fas fa-chalkboard-teacher"></i> <strong> {{'schoolar-subjects'|translate}}</strong>
                        <button type="button" class=" btn btn-primary float-right" (click)="addSubject()">
                          <div class="flex-center">
                            <span class="margin-right-05">{{'add-subject'|translate}}</span>
                            <mat-icon svgIcon="plus"></mat-icon>
                          </div>
                        </button>
                      </h2>
                     
                      <p class="pb-3">{{'select-subjects-intro-text'|translate}}</p>
                    </div>
                    <div class="form-group col-md-12 p-2 teacher-materials-box" 
                      *ngFor="let subject of subjectsFormArray.controls; let index = index; let last = last; let first = first">
                          
                            <div class="flex-end">
                              <button mat-icon-button (click)="removeSubject(index)">
                                <mat-icon>clear</mat-icon>
                              </button>
                            </div>
          
                            <div [formGroupName]="index">
          
                              <mat-form-field appearance="legacy" *ngIf="!subject?.value?.name">
                                <mat-label>{{'subject'|translate}}</mat-label>
                                <mat-select class="form-control" formControlName="study_lesson" (selectionChange)="onChangeStudyLesson($event,subject)">
                                  <mat-option [value]="subject" *ngFor="let subject of subjects" mult>{{subject.name}}
                                  </mat-option>
                                </mat-select>
                                <button mat-icon-button matPrefix *ngIf="subject?.value?.study_lesson" type="button"
                                  (click)="subject.patchValue({study_lesson:''});subject.get('study_lesson').markAsUntouched() ;$event.stopPropagation();">
                                  <mat-icon svgIcon="close-circle" color=""></mat-icon>
                                </button>
                                <mat-error *ngIf="(subject.controls.study_lesson?.invalid && subject.controls.study_lesson?.touched)">
                                  {{'valid-select'|translate}}
                                </mat-error>
                              </mat-form-field>
          
                              <div class="margin-vertical-05 flex-center"
                                *ngIf="!subject?.value?.name && !subject?.value?.study_lesson?.id">
                                {{'or-write-the-name'|translate}}
                              </div>
                              <!-- name other activity -->
                              <mat-form-field appearance="legacy" *ngIf="!subject?.value?.study_lesson?.id">
                                <mat-label>{{'name'|translate}}</mat-label>
                                <input class="form-control" matInput formControlName="name">
                                <mat-error *ngIf="(subject.controls.name?.invalid && subject.controls.name?.touched)">
                                  {{'valid-input'|translate}}
                                </mat-error>
                              </mat-form-field>
          
                             <!-- Niveles-->
                              <mat-form-field appearance="legacy" class="margin-top-05">
                                <mat-label>{{'levels'|translate}}</mat-label>
                                <mat-select class="form-control" formControlName="lesson_level_id" multiple>
                                  <mat-option [value]="level.id" *ngFor="let level of subjectLevels">{{level.name}}
                                  </mat-option>
                                </mat-select>
                                <mat-error
                                  *ngIf="(subject.controls.lesson_level_id?.invalid && subject.controls.lesson_level_id?.touched)">
                                  {{'valid-select'|translate}}
                                </mat-error>
                              </mat-form-field>
          
                               <!-- price_hour_single -->
                               <mat-form-field appearance="standard" >
                                <mat-label> € {{'per-hour'|translate}}</mat-label>                      
                                <input class="form-control" matInput type="number" formControlName="price_hour_single" [value]="" min="5" max="100">
                                 <mat-error *ngIf="(subject.controls.price_hour_single?.invalid && subject.controls.price_hour_single?.touched)">
                                  {{'valid-input'|translate}}
                                </mat-error> 
                              </mat-form-field>
          
                            </div>
                            <!-- <div class="flex-center margin-top-1">
                              <button type="button" class=" btn btn-primary" (click)="addSubject()">
                                <div class="flex-center">
                                  <span class="margin-right-05">{{'add-subject'|translate}}</span>
                                  <mat-icon svgIcon="plus"></mat-icon>
                                </div>
                              </button>
                            </div> -->
                         
                    </div>
                  </div>
                </div>
              </div>
          
              <div class="row mt-5 p-3">
                <!-- languages-for-foreigners -->
                <div class="col-md-12 border p-3 rounded-card bg-white">
                  <div formArrayName="languages" class="row p-3">
                    <div class="block" style="width: 100%;">
                      <h2 class="pb-3 primary"><i class="fas fa-globe-europe"></i> <strong> {{'languages-for-foreigners'|translate}}</strong>
                        <button type="button" class=" btn btn-primary float-right" (click)="addSubjectLang()">
                          <div class="flex-center">
                            <span class="margin-right-05">{{'add-subject'|translate}}</span>
                            <mat-icon svgIcon="plus"></mat-icon>
                          </div>
                        </button>
                      </h2>
                      <p class="pb-3">{{'select-languages-intro-text'|translate}}</p>
                    </div>
                    <div class="form-group col-md-12 p-2 teacher-materials-box"
                      *ngFor="let subject of subjectsLangFormArray.controls; let index = index; let last = last; let first = first">
          
                      <div class="flex-end">
                        <button mat-icon-button (click)="removeSubjectLang(index)">
                          <mat-icon>clear</mat-icon>
                        </button>
                      </div>
          
                      <div [formGroupName]="index">
          
                        <mat-form-field appearance="legacy" *ngIf="!subject?.value?.name">
                          <mat-label>{{'language'|translate}}</mat-label>
                          <mat-select class="form-control" formControlName="study_lesson" (selectionChange)="onChangeStudyLesson($event,subject)">
                            <mat-option [value]="language" *ngFor="let language of languages">{{language.name}}
                            </mat-option>
                          </mat-select>
                          <button mat-icon-button matPrefix *ngIf="subject?.value?.study_lesson" type="button"
                            (click)="subject.patchValue({study_lesson:''});subject.get('study_lesson').markAsUntouched() ;$event.stopPropagation();">
                            <mat-icon svgIcon="close-circle" color=""></mat-icon>
                          </button>
                          <mat-error *ngIf="(subject.controls.study_lesson?.invalid && subject.controls.study_lesson?.touched)">
                            {{'valid-select'|translate}}
                          </mat-error>
                        </mat-form-field>
          
                        <div class="margin-vertical-05 flex-center"
                          *ngIf="!subject?.value?.name && !subject?.value?.study_lesson?.id">
                          {{'or-write-the-name'|translate}}
                        </div>
          
                        <mat-form-field appearance="legacy" *ngIf="!subject?.value?.study_lesson?.id">
                          <mat-label>{{'name'|translate}}</mat-label>
                          <input class="form-control" matInput formControlName="name">
                          <mat-error *ngIf="(subject.controls.name?.invalid && subject.controls.name?.touched)">
                            {{'valid-input'|translate}}
                          </mat-error>
                        </mat-form-field>
          
                        <mat-form-field appearance="legacy" class="margin-top-05">
                          <mat-label>{{'levels'|translate}}</mat-label>
                          <mat-select class="form-control" formControlName="lesson_level_id" multiple>
                            <mat-option [value]="level.id" *ngFor="let level of languageLevels">{{level.name}}
                            </mat-option>
                          </mat-select>
                          <mat-error
                            *ngIf="(subject.controls.lesson_level_id?.invalid && subject.controls.lesson_level_id?.touched)">
                            {{'valid-select'|translate}}
                          </mat-error>
                        </mat-form-field>
          
                        <!-- price_hour_single -->
                        <mat-form-field appearance="standard" >
                          <mat-label> € {{'per-hour'|translate}}</mat-label>                      
                          <input class="form-control" matInput type="number" formControlName="price_hour_single" [value]="" min="5" max="100">
                            <mat-error *ngIf="(subject.controls.price_hour_single?.invalid && subject.controls.price_hour_single?.touched)">
                            {{'valid-input'|translate}}
                          </mat-error> 
                        </mat-form-field>
                      </div>
          
                            
          
                      <!-- <div class="flex-center margin-top-1">
                        <button type="button" class=" btn btn-primary" (click)="addSubjectLang()">
                          <div class="flex-center">
                            <span class="margin-right-05">{{'add-another-1'|translate}}</span>
                            <mat-icon svgIcon="plus"></mat-icon>
                          </div>
                        </button>
                      </div> -->
                    </div>
                  </div>
                </div>
              </div>
          
              <div class="row mt-5 p-3">
                <!-- other-activities -->
                <div class="col-md-12 border p-3 rounded-card bg-white">
                  <div formArrayName="other_activities" class="row p-3">
                    <div class="block" style="width: 100%;">
                      <h2 class="pb-3 primary"><i class="far fa-bookmark"></i> <strong>  {{'other-activities'|translate}}</strong>
                        <button type="button" class=" btn btn-primary float-right" (click)="addSubjectOtherActivity()">
                          <div class="flex-center">
                            <span class="margin-right-05">{{'add-subject'|translate}}</span>
                            <mat-icon svgIcon="plus"></mat-icon>
                          </div>
                        </button>
                      </h2>
                      <p class="pb-3">{{'select-others-intro-text'|translate}}</p>
                    </div>
                    <div class="form-group col-md-12 p-2 teacher-materials-box"
                      *ngFor="let subject of subjectsOtherActivityFormArray.controls; let index = index; let last = last; let first = first">
          
                      <div class="flex-end">
                        <button mat-icon-button (click)="removeSubjectOtherActivity(index)">
                          <mat-icon>clear</mat-icon>
                        </button>
                      </div>
          
                      <div [formGroupName]="index">
          
                        <mat-form-field appearance="legacy" *ngIf="!subject?.value?.name">
                          <mat-label>{{'subject'|translate}}</mat-label>
                          <mat-select class="form-control" formControlName="study_lesson" (selectionChange)="onChangeStudyLesson($event,subject)">
                            <mat-option [value]="other_activity" *ngFor="let other_activity of other_activities" mult>{{other_activity.name}}
                            </mat-option>
                          </mat-select>
                          <button mat-icon-button matPrefix *ngIf="subject?.value?.study_lesson" type="button"
                            (click)="subject.patchValue({study_lesson:''});subject.get('study_lesson').markAsUntouched() ;$event.stopPropagation();">
                            <mat-icon svgIcon="close-circle" color=""></mat-icon>
                          </button>
                          <mat-error *ngIf="(subject.controls.study_lesson?.invalid && subject.controls.study_lesson?.touched)">
                            {{'valid-select'|translate}}
                          </mat-error>
                        </mat-form-field>
        
                        <div class="margin-vertical-05 flex-center"
                        *ngIf="!subject?.value?.name && !subject?.value?.study_lesson?.id">
                        {{'or-write-the-name'|translate}}
                       </div>

                       <ng-container *ngIf="!subject?.value?.study_lesson?.id">
                        <mat-form-field appearance="legacy" class="margin-top-05">
                          <mat-label>{{'name'|translate}}</mat-label>
                          <input class="form-control" matInput formControlName="name">
                          <mat-error *ngIf="(subject.controls.name?.invalid && subject.controls.name?.touched)">
                            {{'valid-input'|translate}}
                          </mat-error>
                        </mat-form-field>
                      </ng-container>

                        <!-- price_hour_single -->
                        <mat-form-field appearance="standard" >
                          <mat-label> € {{'per-hour'|translate}}</mat-label>
                          <input class="form-control" matInput formControlName="price_hour_single" min="5" max="100">
                          <mat-error *ngIf="(subject.controls.price_hour_single?.invalid && subject.controls.price_hour_single?.touched)">
                            {{'valid-input'|translate}}
                          </mat-error>
                        </mat-form-field>
                      </div>
          
                    </div>
                  </div>
                </div>
              </div>

              <!-- Certificates -->
              <div class="mat-h3 margin-top-2">
                {{ "certificates" | translate }}
              </div>
              <div formArrayName="certificates">
                <mat-card
                  class="form-group margin-top-1 mat-elevation-z4"
                  *ngFor="
                    let certificate of certificatesFormArray.controls;
                    let index = index;
                    let last = last;
                    let first = first
                  "
                >
                  <div class="flex-end">
                    <button mat-icon-button (click)="removeCertificate(index)">
                      <mat-icon svgIcon="minus-circle" color="warn"></mat-icon>
                    </button>
                  </div>
                  <div [formGroupName]="index">
                    <div>
                      <div>
                        <!-- type -->
                        <mat-form-field appearance="legacy">
                          <mat-label>{{ "your-education" | translate }}</mat-label>
                          <input class="form-control" matInput formControlName="type" type="text" />
                          <mat-error
                            *ngIf="
                              certificate.controls.type?.invalid &&
                              certificate.controls.type?.touched
                            "
                          >
                            {{ "valid-input" | translate }}
                          </mat-error>
                        </mat-form-field>

                        <!-- issued_by -->
                        <mat-form-field appearance="legacy" class="margin-top-1">
                          <mat-label>{{ "issued_by" | translate }}</mat-label>
                          <input class="form-control" matInput formControlName="issued_by" />
                          <mat-error
                            *ngIf="
                              certificate.controls.issued_by?.invalid &&
                              certificate.controls.issued_by?.touched
                            "
                          >
                            {{ "valid-input" | translate }}
                          </mat-error>
                        </mat-form-field>

                        <!-- study_years -->
                        <mat-form-field appearance="legacy" class="margin-top-1">
                          <mat-label>{{ "study_years" | translate }}</mat-label>
                          <input
                            class="form-control"
                            matInput
                            formControlName="study_years"
                            placeholder="YYYY-YYYY"
                          />
                          <mat-error
                            *ngIf="
                              certificate.controls.study_years?.invalid &&
                              certificate.controls.study_years?.touched
                            "
                          >
                            {{ "valid-input" | translate }}
                          </mat-error>
                        </mat-form-field>

                        <!-- document_base64 -->
                        <div
                          class="mat-h4 margin-top-1"
                          [class.red]="
                            certificate.controls.document?.invalid &&
                            certificate.controls.document?.touched
                          "
                        >
                          {{ "attach-supporting-documentation" | translate }}
                        </div>
                        <div class="flex-center">
                          <mat-icon
                            svgIcon="certificate"
                            *ngIf="
                              !certificate.value.document_base64;
                              else certificateTemplate
                            "
                            (click)="certificateFile.click()"
                            class="margin-top-1 gallery-icon"
                          ></mat-icon>
                          <input
                            #certificateFile
                            type="file"
                            accept="image/png,image/jpeg,application/pdf,.doc,.docx"
                            (change)="
                              onSelectCertificate(
                                $event.target,
                                index,
                                certificate.value.id_image
                              )
                            "
                            style="display: none"
                          />

                          <ng-template #certificateTemplate>
                            <div
                              *ngIf="
                                certificate.value.document.type.includes('image/');
                                else fileTemplate
                              "
                              class="flex-center"
                            >
                              <img
                                [id]="'certificate-' + certificate.value.id_image"
                                class="margin-top-1 img-2"
                                (click)="certificateFile.click()"
                              />
                            </div>
                            <ng-template #fileTemplate>
                              <div
                                class="flex-center-column margin-top-1 cursor-pointer"
                                (click)="certificateFile.click()"
                              >
                                <mat-icon
                                  svgIcon="file"
                                  class="file-icon"
                                ></mat-icon>
                                <div class="margin-top-05">
                                  {{ certificate.value.document.name }}
                                </div>
                              </div>
                            </ng-template>
                          </ng-template>
                        </div>
                        <div class="mat-caption gray margin-top-05">
                          {{ "file-limitator-text-1" | translate }}
                        </div>
                      </div>
                    </div>
                  </div>
                </mat-card>
                <div class="flex-center margin-top-1">
                  <button
                    type="button"
                    class="btn btn-success"
                    (click)="addCertificate()"
                  >
                    <div class="flex-center">
                      <span class="margin-right-05">{{
                        "add-certificate" | translate
                      }}</span>
                      <mat-icon svgIcon="plus"></mat-icon>
                    </div>
                  </button>
                </div>
              </div>

              <!-- Button -->
              <div class="button-group margin-top-1 margin-bottom-05">
                <button
                  mat-raised-button
                  color="primary"
                  type="button"
                  matStepperPrevious
                >
                  <span>{{ "previous" | translate }}</span>
                </button>
                <button
                  mat-raised-button
                  color="primary"
                  type="button"
                  (click)="registerTeacher(stepper)"
                  [class.spinner]="loading"
                  [disabled]="loading"
                >
                  <span>{{ "send" | translate }}</span>
                </button>
              </div>
            </div>
          </form>
        </mat-step>
      
      </mat-horizontal-stepper>

    </div>

    <div class="col md-4">
      <div class="teacher-register-right">
        <img src="../../../assets/img/register-teacher-banner.jpg" alt="" class="img-fluid" />
        <ul class="list-group">
          <li class="list-group-item" aria-current="true"><strong>ENSEÑA ONLINE</strong></li>
          <li class="list-group-item"><i class="far fa-clock"></i> Horarios flexibles</li>
          <li class="list-group-item"><i class="fas fa-chalkboard-teacher"></i> Miles de alumnos</li>
          <li class="list-group-item"><i class="fas fa-user-graduate"></i> Clases individualizadas</li>
          <li class="list-group-item"><i class="fas fa-tools"></i> Herramientas avanzadas</li>
          <li class="list-group-item"><i class="far fa-handshake"></i> Sistema amigable</li>
        </ul>
        <a class="btn btn-primary mt-4" href="https://www.wordiix.com" role="button" target="_blank">VISITAR WEB DE WORDIIX</a>
      </div>    
    </div>



  </div>
</div>

<app-footer></app-footer>
